import { types } from "./types";

const ResultsReducer = (state, action) => {
  switch (action.type) {
    case types.SET_RESULT_STATUS:
      return action.payload;
    case types.SET_INPUT_FOR_RESULT:
      return action.payload;
    case types.SET_LAT_LONG:
      return action.payload;
    case types.SET_QUALITYSCHEME_FILTERED:
      return action.payload;
    default:
      return state;
  }
};

export { ResultsReducer };
